// font references
// 10px = 0.625 rem
// 12px = 0.75 rem
// 14px = 0.875 rem
// 15px = 0.938 rem
// 16px = 1.00 rem
// 20px = 1.25 rem
// 24px = 1.5 rem
// 30px = 1.875 rem
// 32px = 2 rem

const variables = {
  $size_1: 10,
  $size_2: 12,
  $size_3: 14,
  $size_4: 15,
  $size_5: 16,
  $size_6: 20,
  $size_7: 24,
  $size_8: 30,
  $size_9: 32,
  $size_half: 5,
  $size_quarter: 2.5,

  $brandColor: "#00AEB4",
  $background: "#fafafa",
  $highlight: "#F5F5F5",
  $textDark: "#5c6175",
  $textLight: "#B2BEC3",
  $divider: "#f3f3f3",
  $disabledText: "#e1e1e1",
  $danger: "#e76f51",
  $success: "#69c5a2",
  $warning: "#e9c46a",
  $cardBackground: "#fff",
  $fontFamily: "Montserrat",
  $buttonColor: "#00AEB4",
  $priceColor: "#F9A26C",
  $disabledButton: "#B2BEC3"
};

export default variables;
